<!-- 主播广场 -->
<template>
  <div class="page">
    <div class="content">
      <hosts-filter @changeQuery="changeQuery"></hosts-filter>
      <hosts-table :commonQuery="commonQuery" @changeQuery="changeQuery"></hosts-table>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      commonQuery: {},
    };
  },
  components: {
    hostsFilter:() => import('./hostsFilter.vue'),
    hostsTable:() => import('./hostsTable.vue')
  },
  created() {
    
  },
  watch: {
    
  },
  computed: {
  },
  methods: {
    changeQuery(query) {
        this.commonQuery = query
    },
  }
};
</script>

<style lang='less' scoped>

</style>